import { PromotionsApiClient, } from '@fourthwall/services/dist/PromotionsApiClient';
import { createQueryHook } from '@fourthwall/utils/dist/queries';
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize';
export const usePromotionsQuery = createQueryHook(PromotionsApiClient.getPromotions, {
    queryKey: ['promotions'],
    select: (data) => ({
        ...data,
        promotions: data.promotions.map((promotion) => ({
            ...promotion,
            title: 'title' in promotion ? decodeHtmlEntities(promotion.title) : undefined,
        })),
    }),
});
